(ns minorodata.connections.sources.netsuite
  (:require
   [minorodata.app.utils :as app.utils]
   [clojure.string :as string]))


(def source
  {:id           "netsuite-jdbc"
   :name         "Netsuite"
   :description  "NetSuite is the leading integrated cloud business software suite, including business accounting, ERP, CRM and ecommerce software."
   :image-source "netsuite.png"
   :tags         ["data-import"]
   :enabled      true
   :message-queue-enabled true

   :preview-formatter
   (fn [source]
     (str "Server Data Source: "
          (get-in source [:source-db-creds :serverdatasource])))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [port user password extra name description
                    server-data-source account-id role-id
                    consumer-key consumer-secret token-id token-secret]} data]
        {:source-type "netsuite-jdbc"
         :name        name
         :description description

         :source
         {:server-data-source server-data-source
          :account-id         account-id
          :role-id            role-id
          :consumer-key       consumer-key
          :consumer-secret    consumer-secret
          :token-id           token-id
          :token-secret       token-secret
          :source-db-creds {:dbtype             "ns"
                            :classname          "com.netsuite.jdbc.openaccess.OpenAccessDriver"
                            :property-separator ";"
                            :dbname-separator   ""
                            :serverdatasource   server-data-source
                            :host               (-> account-id
                                                    (string/lower-case)
                                                    (string/replace #"_" "-")
                                                    (str ".connect.api.netsuite.com"))
                            :port               port
                            :user               user
                            :password           password
                            :dbname             ""
                            :encrypted          "1"
                            :negotiatesslclose  "false"
                            :extra              extra
                            :customproperties   (str "(AccountID=" account-id ";RoleID=" role-id ")")}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [source-db-creds]} source
            {:keys [customproperties serverdatasource]} source-db-creds
            parse-props (fn [prop]
                          (some->> customproperties
                                   (re-find (re-pattern (str "(?i)" prop "=([^;)]*)")))
                                   second))]
        (merge (select-keys source [:server-data-source :account-id :role-id :consumer-key :consumer-secret :token-id :token-secret])
               (select-keys source-db-creds [:port :user :password :extra])
               {:server-data-source serverdatasource
                :account-id         (parse-props "AccountID")
                :role-id            (parse-props "RoleID")
                :name               name
                :description        description})))

    :validate (constantly nil)

    :id :netsuite-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:block-type :input
              :label      "Port"
              :name       :port
              :required   true
              :value      "1708"}

             {:block-type :select
              :label      "Server Data Source"
              :name       :server-data-source
              ;; note that the server data source string is case sensitive, the connector and jdbc driver
              ;; expects the casing defined here exactly
              :options    [{:name "NetSuite.com"  :value "NetSuite.com"}
                           {:name "NetSuite2.com" :value "NetSuite2.com"}]
              :required   true
              :value      ""}
             {:content "The data exposed from this data source is available from the Connect Browser"
              :conditions [[:eq [:server-data-source :value] "NetSuite.com"]]}
             {:content "The data exposed from this data source is consistent with the Suite Analytics Workbook. Details about each record can be found in the Records Catalog"
              :conditions [[:eq [:server-data-source :value] "NetSuite2.com"]]}

             {:block-type :input
              :label      "Account ID"
              :name       :account-id
              :required   true
              :value      ""}
             {:block-type :input
              :label      "Role ID"
              :name       :role-id
              :required   true
              :value      ""}

             {:block-type :input
              :label      "Database User"
              :name       :user
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite.com"]]}
             {:block-type :input
              :label      "Database Password"
              :name       :password
              :type       :password
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite.com"]]}

             {:block-type :input
              :label      "Consumer Key"
              :name       :consumer-key
              :type       :password
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite2.com"]]}
             {:block-type :input
              :label      "Consumer Secret"
              :name       :consumer-secret
              :type       :password
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite2.com"]]}
             {:block-type :input
              :label      "Token ID"
              :name       :token-id
              :type       :password
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite2.com"]]}
             {:block-type :input
              :label      "Token Secret"
              :name       :token-secret
              :type       :password
              :value      ""
              :conditions [[:eq [:server-data-source :value] "NetSuite2.com"]]}

             {:block-type :input
              :label      "Extra Parameters"
              :name       :extra
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}

   :extract-form
   {:format-for-api
    (fn [{:keys [name description status
                 source-schema source-table columns
                 update-column unique-columns extract-type auto-ingest-new-columns
                 destination-table action extraction-method
                 backfill-type backfill-years backfill-period
                 start-date end-date
                 chunk-interval chunk-parallelism created-column]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [(app.utils/keep-non-nil-keys
                    {:action            action
                     :source-table      (str source-schema "." source-table)
                     :extract-type      extract-type
                     :extraction-method extraction-method
                     :chunk-interval    chunk-interval
                     :chunk-parallelism chunk-parallelism
                     :created-column    (when (= "key-chunked" extraction-method)
                                          created-column)
                     :backfill-type     backfill-type
                     :backfill-years    backfill-years
                     :backfill-period   backfill-period
                     :start-date        start-date
                     :end-date          end-date
                     :destination-table destination-table
                     :columns           columns
                     :auto-ingest-new-columns auto-ingest-new-columns
                     :update-column     (when (or (= "incremental" extract-type)
                                                  (contains? #{"time-chunked" "key-chunked"} extraction-method))
                                          update-column)
                     :unique-columns    unique-columns})]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config source-id]} data

            extract (get-in config [:extracts 0])

            {:keys [columns source-table auto-ingest-new-columns]} extract

            [_ schema table] (re-matches #"(.*?)\.(.*)" (or source-table ""))]

        (merge
         (select-keys extract [:action :destination-table :extract-type :update-column :unique-columns :auto-ingest-new-columns
                               :extraction-method :backfill-type :backfill-years :backfill-period :start-date :end-date
                               :chunk-interval :chunk-parallelism :created-column])
         {:auto-ingest-new-columns (or auto-ingest-new-columns false)}
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :source-id     source-id

           :source-schema schema
           :source-table  table

           :columns (if (some? columns)
                      columns
                      [])}))))

    :validate (constantly nil)

    :id :netsuit-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract configuration"}

             {:block-type :form-value
              :name       :source-id}

             {:block-type :database-metadata-select
              :label      "Schema"
              :loading-text "Loading schemas..."
              :disabled-text "Select schema"
              :empty-option-text "No schemas available"
              :required   true
              :value      ""
              :name       :source-schema

              :fetch-type      :schemas

              :options-sub     :connections.subs/database-schemas
              :upstream-deps   []
              :downstream-deps [:source-table :update-column :columns :unique-columns]}

             {:block-type :database-metadata-select
              :label      "Table"
              :loading-text "Loading tables..."
              :disabled-text "Select table"
              :empty-option-text "Select valid schema first"
              :required   true
              :value      ""
              :name       :source-table

              :fetch-type   :tables
              :schema-field :source-schema

              :options-sub     :connections.subs/database-tables
              :upstream-deps   [:source-schema]
              :downstream-deps [:update-column :columns :unique-columns]}

             {:block-type :database-metadata-select
              :label      "Columns"
              :loading-text "Loading columns..."
              :disabled-text "Select columns"
              :empty-option-text "Select valid table first"

              :required   true
              :multiple   true

              :value      []
              :name       :columns

              :select-all         true
              :select-all-options :connections.subs/database-columns

              :fetch-type   :columns
              :schema-field :source-schema
              :table-field  :source-table

              :options-sub      :connections.subs/database-columns
              :options-meta-sub :connections.subs/database-columns-with-metadata
              :upstream-deps    [:source-schema :source-table]
              :downstream-deps  []}

             {:block-type        :database-metadata-select
              :label             "Unique columns (ignored in latest version)"
              :loading-text      "Loading columns..."
              :disabled-text     "Select columns"
              :empty-option-text "Select column"
              :value             []
              :name              :unique-columns

              :select-all            true
              :select-all-options    :connections.subs/database-primary-keys

              :required   true
              :multiple   true

              :fetch-type   :primary-keys
              :schema-field :source-schema
              :table-field  :source-table

              :options-sub     :connections.subs/database-columns-with-pk-marker
              :upstream-deps   [:source-schema :source-table :columns]
              :downstream-deps []}

             {:content "Please specify a column or several columns that contain(s) unique values for each row. This is to ensure that there is no missing data."}

             {:block-type :checkbox
              :label      "Auto ingest new columns"
              :name       :auto-ingest-new-columns
              :type       :checkbox
              :value      false
              :doc        [:span "When this is selected, any new columns will be automatically ingested and added to an existing destination table"]}

             {:block-type :subtitle
              :content    "Data loading options"
              :doc        [:span "See documentation " [:a {:href "https://docs.kleene.ai/docs/netsuite" :target :_blank} "here"] " for more information"]}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Full"          :value "backfill"}
                           {:name "Custom Dates" :value "custom-dates"}
                           {:name "Incremental"   :value "incremental"}
                           {:name "Decremental"   :value "decremental"}]
              :required   true
              :value      nil}

             {:block-type :database-metadata-select
              :label      "Incremental column"
              :loading-text "Loading columns..."
              :disabled-text "Select column"
              :empty-option-text "Select column"
              :value      ""
              :name       :update-column
              :required   true

              :skip-request    true
              :options-sub     :connections.subs/database-columns
              :upstream-deps   [:source-schema :source-table]
              :downstream-deps []
              :conditions      [[:eq [:extract-type :value] "incremental"]]}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "backfill"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :select
              :label      "Extraction method"
              :name       :extraction-method
              :options    [{:name "Full Stream"    :value "planned"}
                           {:name "Ordered Chunks" :value "ordered-chunk"}
                           {:name "Time Chunks"    :value "time-chunked"}
                           {:name "Key Chunks"     :value "key-chunked"}]
              :required   true
              :value      "planned"
              :conditions [[:eq [:extract-type :value] "incremental"]]}

             {:block-type :select
              :label      "Extraction method"
              :name       :extraction-method
              :options    [{:name "Time Chunks"    :value "time-chunked"}]
              :required   true
              :value      "time-chunked"
              :conditions [[:eq [:extract-type :value] "decremental"]]}

             {:block-type :select
              :label      "Extraction method"
              :name       :extraction-method
              :options    [{:name "Full Stream"    :value "planned"}
                           {:name "Time Chunks"    :value "time-chunked"}
                           {:name "Key Chunks"     :value "key-chunked"}]
              :required   true
              :value      "planned"
              :conditions [[:eq [:extract-type :value] "backfill"]]}

             {:block-type :select
              :label      "Extraction method"
              :name       :extraction-method
              :options    [{:name "Time Chunks"    :value "time-chunked"}
                           {:name "Key Chunks"     :value "key-chunked"}]
              :required   true
              :value      "planned"
              :conditions [[:eq [:extract-type :value] "custom-dates"]]}

             {:block-type :select
              :label      "Chunk interval"
              :name       :chunk-interval
              :options    [{:name "Day" :value "day"}
                           {:name "Hour"  :value "hour"}
                           {:name "Minute"  :value "minute"}]
              :required   true
              :value      "day"
              :conditions [[:eq [:extraction-method :value] "time-chunked"]]}

             {:content "Time chunks extraction method requires that you tell us which column is a timestamp to check from which date to start."
              :conditions [[:and [[:extraction-method :value] [:extract-type :value]] ["time-chunked" "backfill"]]]}

             {:content "Key chunks is currently only recommended for transactionLine extracts."
              :conditions [[:eq [:extraction-method :value] "key-chunked"]]}

             {:block-type :input
              :label      "Parallel workers"
              :name       :chunk-parallelism
              :type       :number
              :value      "1"
              :doc        [:span "Defaults to 1. The recommended amount depends on NetSuite capacity — higher isn't always better."]
              :conditions [[:eq [:extraction-method :value] "key-chunked"]]}

             {:block-type :database-metadata-select
              :label      "Creation date column"
              :loading-text "Loading columns..."
              :disabled-text "Select column"
              :empty-option-text "Select column"
              :value      ""
              :name       :created-column

              :skip-request    true
              :options-sub     :connections.subs/database-columns
              :upstream-deps   [:source-schema :source-table]
              :downstream-deps []
              :doc        [:span "The column holding each row's creation date (e.g. linecreateddate). Recommended: enables planning chunk sizes around where the extract window's rows live."]
              :conditions [[:eq [:extraction-method :value] "key-chunked"]]}
             {:block-type :database-metadata-select
              :label      "Timestamp column"
              :loading-text "Loading columns..."
              :disabled-text "Select column"
              :empty-option-text "Select column"
              :value      ""
              :name       :update-column
              :required   true

              :skip-request    true
              :options-sub     :connections.subs/database-columns
              :upstream-deps   [:source-schema :source-table]
              :downstream-deps []
              :conditions      [[:eq [:extraction-method :value] "time-chunked"]
                                [:eq [:extraction-method :value] "key-chunked"]]}

             {:block-type :select
              :label      "Backfill type"
              :name       :backfill-type
              :options    [{:name "Years" :value "year"}
                           {:name "Months"  :value "month"}
                           {:name "Days"  :value "day"}]
              :required   true
              :value      "year"
              :conditions [[:and [[:extract-type :value] [:extraction-method :value]] ["backfill" "time-chunked"]]
                           [:and [[:extract-type :value] [:extraction-method :value]] ["backfill" "key-chunked"]]]}

             {:block-type :select
              :label      "Backfill type"
              :name       :backfill-type
              :options    [{:name "Years" :value "year"}
                           {:name "Months"  :value "month"}]
              :required   true
              :value      "year"
              :conditions [[:and [[:extract-type :value] [:extraction-method :value]] ["decremental" "time-chunked"]]]}

             {:block-type :input
              :label      "Backfill Years"
              :name       :backfill-years
              :type       :number
              :value      "3"
              :doc        [:span "This will be what it defaults to if it fails to get the date from netsuite (usually from too much data causing the query to time out)"]
              :conditions [[:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "time-chunked" "year"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "ordered-chunk" "year"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "key-chunked" "year"]]]}

             {:block-type :input
              :label      "Backfill Period"
              :name       :backfill-period
              :type       :number
              :value      "3"
              :doc        [:span "This will be what it defaults to if it fails to get the date from netsuite (usually from too much data causing the query to time out)"]
              :conditions [[:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "time-chunked" "day"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "time-chunked" "month"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "key-chunked" "day"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["backfill" "key-chunked" "month"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["decremental" "time-chunked" "year"]]
                           [:and [[:extract-type :value] [:extraction-method :value] [:backfill-type :value]] ["decremental" "time-chunked" "month"]]]}

             {:block-type :date-picker
              :label      "Start date"
              :name       :start-date
              :required   true
              :conditions [[:eq [:extract-type :value] "custom-dates"]]}

             {:block-type :date-picker
              :label      "End date"
              :name       :end-date
              :required   true
              :conditions [[:eq [:extract-type :value] "custom-dates"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
